var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRoof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "125.92 180.32 448.15 199.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m566.16 344.4-100.24-75.598s0-0.55859-0.55859-0.55859v-0.55859l-0.003906-86.242h-41.441v51.52 0.55859 0.55859c-0.55859 0.55859-0.55859 0.55859-1.1211 0.55859-0.55859 0-0.55859 0-1.1211-0.55859l-71.676-53.758-216.16 164.08c-8.9609 6.7188-10.641 19.602-3.3594 28 3.3594 3.9219 8.3984 6.7188 14 7.2812 5.6016 0.55859 11.199-1.1211 15.121-3.9219l189.28-143.36h0.55859 0.55859 1.1211 0.55859l188.72 143.36c4.4805 3.3594 9.5195 5.0391 15.121 3.9219 5.6016-0.55859 10.641-3.3594 14-7.2812 7.2812-8.9609 5.6016-21.281-3.3594-28.004z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoof);
export default __webpack_public_path__ + "static/media/icon-roof.6f8efc05fe5bf384fe1a53bc4510b25f.svg";
export { ForwardRef as ReactComponent };